import { LogoutOutlined } from '@mui/icons-material';
import { Divider, List } from '@mui/material';
import { Fragment } from 'react';

import { useLogout, useUserEmailIfLoggedIn } from '../../../auth/authentication';
import { ReturnComponent } from '../../../utils/reactTypes';
import { useGlobalDrawerItems } from '../lib/useGlobalDrawerItems';
import { GlobalDrawerHeader } from './GlobalDrawerHeader';
import { GlobalDrawerItem } from './GlobalDrawerItem';

export const GlobalDrawerItems = (): ReturnComponent => {
    const currentUserEmail = useUserEmailIfLoggedIn();

    const logout = useLogout();

    const DRAWER_ITEMS = useGlobalDrawerItems();

    return (
        <>
            <GlobalDrawerHeader />
            <List
                component={'nav'}
                sx={{
                    bgcolor: 'transparent',
                }}
            >
                {DRAWER_ITEMS.filter((item) => item.canAccess).map((item) => (
                    <Fragment key={item.label}>
                        {item.isDivider && <Divider sx={{ mx: 3, my: 1 }} />}
                        <GlobalDrawerItem item={item} />
                    </Fragment>
                ))}
                <Divider sx={{ mx: 3, my: 1 }} />
                <GlobalDrawerItem
                    item={{
                        label: 'Logout',
                        subLabel: currentUserEmail ?? undefined,
                        icon: <LogoutOutlined />,
                        canAccess: true,
                        onClick: logout,
                    }}
                />
            </List>
        </>
    );
};
